import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from "../../../api/axiosInstance";
export const fetchOrders = createAsyncThunk(
    "orders/fetchOrders",
    async ({ payload, token, language }) => {
      try {
        const response = await axiosInstance.post("/api/Customer/GetAllRequest", {
          draw:payload.draw,
          start: payload.start,
          length: payload.length,
          search: payload.search,
          isWeb: true,
          text:payload.text,
          startDate: payload.startDate,
          endDate: payload.endDate,
          actionDate: null,
          customerFk: payload.customerFk,
          orderStatus: payload.orderStatus,
          year: payload.year,
        },  {
          headers: {
            Authorization: `Bearer ${token}`,
            "lang": language === "English" ? "2" : "1",
          },
        });
        const data = response.data?.message ? JSON.parse(response.data.message).Data : [];
        return data;
      } catch (error) {
        console.error("Error fetching orders: ", error);
        throw error;
      }
    }
  );
  

  const orderTable = createSlice({
    name: "orders",
    initialState: {
      orders:[],
      loading: false,
        error: null, 
    },
    reducers: {},
    extraReducers: builder => {
        builder
          .addCase(fetchOrders.pending, state => {
            state.loading = true;
          })
          .addCase(fetchOrders.fulfilled, (state, action) => {
            state.orders = action.payload || [];
            state.loading = false;
          })
          .addCase(fetchOrders.rejected, (state, action) => {
            console.error("Error fetching orders:", action.error); // Log error if rejected
            state.loading = false;
          });
      },
      
  });

export const selectOrders = state => state.orders;
export default orderTable.reducer;
